
// @flow
import React from 'react'
import { useTranslation } from 'react-i18next'
import '../styles/FooterBar.scss'

export default function FooterBar(props) {
  const { t } = useTranslation()
  if (props.orderType === 2)
    return (
      <div className="footer-bar">
        {t('footer.kiosk')}<a href={`https://we-eats.com`}>WE EATS</a>
      </div>
    )
  else
    return (
      <div className="footer-bar">
        {t('footer.clickCollect')}<a href={`https://we-eats.com`}>WE EATS</a>
      </div>
    )
}